import React, {
  FC, useCallback,
} from 'react'

import { useDispatch } from 'react-redux'
import cn from 'classnames'
import { useFormikContext } from 'formik'

import style from '@src/pages/ActivationCard/ActivationCard.module.scss'
import { Button } from '@src/components/Button/Button'
import { FieldFormik } from '@src/components/FieldFormik/FieldFormik'
import { AppDispatch } from '@src/store/store'
import { checkPhoneSms } from '@src/store/ducks/auth/thunks'
import { CheckBoxFormik } from '@src/components/CheckBoxFormik/CheckBoxFormik'

type RegistrationFormProps = {
    isLoading?: boolean;
    backError?: any;
}

export const QuestionaryForm: FC<RegistrationFormProps> = ({
  backError, isLoading,
}) => {
  const dispatch = useDispatch<AppDispatch>()
  const {
    values, validateForm, setTouched, setFieldValue,
  } = useFormikContext<any>()
  /*  const handleSetDate = (name:string, newDate: string) => {
      setDate(name, newDate)
    } */

  const handleSendSms = useCallback(async () => {
    const formErrors: any = await validateForm()
    Object.keys(formErrors).forEach((key) => {
      formErrors[key] = true
    })
    const formHasErrors = Object.keys(formErrors).length > 0

    if (!formHasErrors) {
      dispatch(checkPhoneSms(values.phone))
    } else {
      setTouched(formErrors)
    }
  }, [dispatch, setTouched, validateForm, values])

  return (
    <div className={style.questionaryForm}>

      <div className={style.box_1}>
        <FieldFormik
          name="surname"
          placeholder="Фамилия"
          className={cn(style.fieldSize, style.mediumSize)}
          styleError={style.errorSize}
        />
        <FieldFormik
          name="name"
          placeholder="Имя"
          className={cn(style.fieldSize, style.mediumSize)}
          styleError={style.errorSize}
        />
        <FieldFormik
          name="patronymic"
          placeholder="Отчество"
          className={style.fieldSize}
          styleError={style.errorSize}
        />

        {/* <div className={cn(style.genderBlock, style.fieldSize, style.mediumSize)}>
          <div className={style.genderBlock_label}>Укажите Ваш пол</div>
          <div className={style.genderBlock_radios}>
            {genderArr.map((genderT: any) => (
              <FormikRadio
                key={genderT.id}
                classNames={style.radioBtn}
                name="gender"
                type="radio"
                label={genderT.title}
                value={genderT.id.toString()}
              />
            ))}
          </div>
          <ErrorMessage className={cn(style.error, style.genderError)} name="gender" component="div" />
        </div> */}
        {/* <div className={cn(style.fieldSize, style.mediumSize)}>
          <RegisterDatepicker setDate={handleSetDate} classNames={style.dateSelect} />
          <ErrorMessage className={cn(style.error, style.dateError)} name="birthDate" component="div" />
        </div> */}
        {/* <FieldFormik
          name="address"
          placeholder="Город"
          className={cn(style.fieldSize, style.mediumSize)}
          styleError={style.errorSize}
        />
        <FieldFormik
          name="email"
          placeholder="Email"
          className={cn(style.fieldSize, style.mediumSize)}
          styleError={style.errorSize}
        /> */}
        <FieldFormik
          name="phone"
          placeholder="Номер телефона"
          mask="+{375} (00) 000-00-00"
          className={style.fieldSize}
          styleError={style.errorSize}
        />
        <FieldFormik
          name="birthDate"
          mask="00-00-0000"
          placeholder="Дата рождения"
          className={style.fieldSize}
          styleError={style.errorSize}
        />
      </div>
      <CheckBoxFormik
        checked={values.isProcessingPersonalData}
        className={style.checkBoxSize}
        name="isProcessingPersonalData"
        label={(
          <span>
            Я даю
            <a
              className={style.link}
              href="/assets/pdf/03-1___1.pdf"
              target="_blank"
            >
              {' '}
              согласие
              {' '}
            </a>
            на обработку моих персональных данных для регистрации на Сайте с целью
            получения электронной карты лояльности;
            <span>*</span>
          </span>
                )}
        onChange={(e) => setFieldValue('isProcessingPersonalData', e.target.checked)}
      />
      <CheckBoxFormik
        checked={values.isAcknowledgedPersonalDataPolicy}
        className={style.checkBoxSize}
        name="isAcknowledgedPersonalDataPolicy"
        label={(
          <span>
            Я подтверждаю, что ознакомлен с
            <a
              className={style.link}
              href="/assets/pdf/politika_obrabotki_personalnyh_dannyh_27_03_25.pdf"
              target="_blank"
            >
              {' '}
              Политикой по обработке персональных данных,
              {' '}
            </a>
            с правами
            субъекта персональных данных и механизмом их реализации;
            <span>*</span>
          </span>
            )}
        onChange={(e) => setFieldValue('isAcknowledgedPersonalDataPolicy', e.target.checked)}
      />
      <CheckBoxFormik
        checked={values.isLoyalty}
        className={style.checkBoxSize}
        name="isLoyalty"
        label={(
          <span>
            Я даю
            <a
              className={style.link}
              href="/assets/pdf/03-6___2.pdf"
              target="_blank"
            >
              {' '}
              согласие
              {' '}
            </a>
            на обработку моих персональных данных для участия в Программе
            лояльности «Дионис-польза очеВИДНА», ознакомлен, понимаю и соглашаюсь со всеми
            условиями
            <a
              className={style.link}
              href="/assets/pdf/programma_loyalnosti_27_03_25.pdf"
              target="_blank"
            >
              {' '}
              Программы лояльности «Дионис-польза очеВИДНА»;
              {' '}
            </a>
            <span>*</span>
          </span>
            )}
        onChange={(e) => setFieldValue('isLoyalty', e.target.checked)}
      />
      <CheckBoxFormik
        checked={values.isPromotionalMail}
        className={style.checkBoxSize}
        name="isPromotionalMail"
        label={(
          <span>
            Я даю
            <a
              className={style.link}
              href="/assets/pdf/03-5___1.pdf"
              target="_blank"
            >
              {' '}
              согласие
              {' '}
            </a>
            на обработку моих персональных данных для информирования о товарах,
            акциях и иных мероприятиях посредством рассылки SMS-сообщений, сообщений в мессенджерах.
          </span>
            )}
        onChange={(e) => setFieldValue('isPromotionalMail', e.target.checked)}
      />
      <CheckBoxFormik
        checked={values.isPoll}
        className={style.checkBoxSize}
        name="isPoll"
        label={(
          <span>
            Я даю
            <a
              className={style.link}
              href="/assets/pdf/03-7___1.pdf"
              target="_blank"
            >
              {' '}
              согласие
              {' '}
            </a>
            на обработку моих персональных данных для проведения опросов,
            статистических и маркетинговых исследований.
          </span>
            )}
        onChange={(e) => setFieldValue('isPoll', e.target.checked)}
      />
      <CheckBoxFormik
        checked={values.isPromotionalGames}
        className={style.checkBoxSize}
        name="isPromotionalGames"
        label={(
          <span>
            Я даю
            <a
              className={style.link}
              href="/assets/pdf/03-4___1.pdf"
              target="_blank"
            >
              {' '}
              согласие
              {' '}
            </a>
            на обработку моих персональных данных для обеспечение моего участия в
            рекламных акциях и играх.
          </span>
            )}
        onChange={(e) => setFieldValue('isPromotionalGames', e.target.checked)}
      />

      <div className={style.btnBlock}>
        {backError && String(backError) && (
        <div className={style.error}>
          *
          {backError}
        </div>
        )}
        <Button
          loading={isLoading}
          htmlType="button"
          type="secondary"
          className={style.btnSize}
          // disabled={!values.isProcessingPersonalData}
          disabled={!values.isProcessingPersonalData || !values.isAcknowledgedPersonalDataPolicy || !values.isLoyalty}
          onClickFunc={handleSendSms}
        >
          Получить смс-код
        </Button>
      </div>
    </div>
  )
}
